import axios from "axios";

export default class RaportService {
  constructor() {
    const isLocal = window.location.hostname === "localhost";
    this.apiBaseUrl = isLocal ? "http://127.0.0.1:7999" : "";
  }

  async login(username, password) {
    try {
      const response = await axios.post(`${this.apiBaseUrl}/api/Proje/login`, {
        Username: username,
        Password: password
      });
      return response;
    } catch (error) {
      console.error("Giriş işlemi sırasında bir hata oluştu:", error);
      throw error;
    }
  }
}
